<template>
  <div class="public-content">
    <div class="breadcrumb">照片库</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 5px;">平台号:</span>
        <el-select clearable v-model="vo.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
          <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
        </el-select>
        <span style="margin:0 5px;">手机号:</span>
        <el-input style="margin:0 10px;" v-model="vo.phone" placeholder="请输入手机号" clearable></el-input>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
      </div>
      <div>
        <!-- <el-button round type="primary" @click="add()">新建模板页信息</el-button> -->
      </div>
    </div>
    <div class="right-main">
      <el-table :data="tableData" border>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="照片数量" prop="count"></el-table-column>
        <el-table-column label="平台号" prop="storeCode"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="color-blue" @click="$router.push({ path: '/photoDetail', query: { phone: scope.row.phone } })">查看</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
  </div>
</template>
<script>
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName } from '@/api/crm'
import { photoPage } from '@/api/auxx.js'
import VPagination from '@/components/Pagination/index'
export default {
  components: {
    VPagination
  },
  data () {
    return {
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      vo: {
        phone: null,
        storeId: null
      },
      storeListByCode: [],
      tableData: []

    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    onSubmit () {
      photoPage({
        data: this.vo,
        params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize }
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.content.map(a => {
              if (a.phone) {
                a.phone = this.$msg.filterBridal(a.phone)
              }
              return a
            })
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }

  }
}
</script>
<style lang="less" scoped>
.right-main {
  padding: 10px;
}

.add-category {
  justify-content: space-between;
}

.keywords {
  display: flex;
  justify-content: space-around;
  // width: 750px;
  align-items: center;

  .el-input {
    width: 180px;
  }
}

@deep: ~">>>";

.infoValue {
  @{deep} .el-input {
    width: 40px;

    input {
      padding: 0 2px;
      text-align: center;
    }
  }
}
</style>
